<template>
    <marquee class="announcement-msg" v-if="walletConfig?.announcement?.value">
        {{walletConfig?.announcement?.value}}
    </marquee>
</template>

<script>
import { marquee } from '@template/utils';
export default {
    name: 'WalletAnnoucement',
    inject: ['walletConfig'],
    components: {
        marquee
    }
}
</script>